<template>
  <div class="header">
    <div class="container-fluid">
      <div class="card mt-5">
        <div class="card-header">
          <h4 class="card-header-title">Mapping Subcon</h4>
          <div class="card-header-action">
            <button class="btn btn-primary btn-pill" type="button" @click="openCreateModal">
              <span class="fe fe-plus"></span>
              Add Mapping
            </button>
          </div>
        </div>

        <div class="card-body">
          <div class="row mb-4">
            <div class="col-md-5 mb-3">
              <label class="form-label">Search</label>
              <input
                v-model="filters.search"
                class="form-control"
                type="text"
                placeholder="Search parent or subcon company"
                @input="onFilterChange">
            </div>
            <div class="col-md-3 mb-3">
              <label class="form-label">Status</label>
              <v-select
                v-model="filters.status"
                :options="statusOptions"
                :reduce="option => option.value"
                label="label"
                placeholder="All Status"
                :clearable="true"
                @input="onFilterChange" />
            </div>
            <div class="col-md-4 mb-3 d-flex align-items-end justify-content-end">
              <button class="btn btn-outline-secondary" type="button" @click="clearFilters">
                <i class="fe fe-x me-1"></i>
                Clear
              </button>
            </div>
          </div>

          <vue-good-table
            :columns="columns"
            :rows="rows"
            :totalRows="pagination.total"
            :isLoading.sync="isLoading"
            :pagination-options="{
              enabled: true,
              mode: 'remote',
              position: 'bottom',
              perPage: pagination.limit,
              setCurrentPage: pagination.page,
              perPageDropdown: [10, 25, 50, 100],
              dropdownAllowAll: false
            }"
            :sort-options="{ enabled: true }"
            style-class="vgt-table border-0 table"
            @on-page-change="onPageChange"
            @on-per-page-change="onPerPageChange">
            <div slot="emptystate" class="text-center font-size-14">
              No subcon mapping found
            </div>

            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field === 'no'">
                {{ (pagination.page - 1) * pagination.limit + props.index + 1 }}
              </span>

              <span v-else-if="props.column.field === 'is_active'">
                <span :class="props.row.is_active ? 'badge bg-success' : 'badge bg-secondary'">
                  {{ props.row.is_active ? 'Active' : 'Inactive' }}
                </span>
              </span>

              <span v-else-if="props.column.field === 'action'">
                <button class="btn btn-sm btn-warning me-2" type="button" title="Edit" @click="openEditModal(props.row)">
                  <i class="fe fe-edit-2"></i>
                </button>
                <button class="btn btn-sm btn-outline-danger me-2" type="button" title="Delete" @click="deleteMapping(props.row)">
                  <i class="fe fe-trash-2"></i>
                </button>
                <button
                  class="btn btn-sm"
                  :class="props.row.is_active ? 'btn-outline-danger' : 'btn-outline-success'"
                  type="button"
                  :title="props.row.is_active ? 'Deactivate' : 'Activate'"
                  @click="toggleStatus(props.row)">
                  <i :class="props.row.is_active ? 'fe fe-slash' : 'fe fe-check'"></i>
                </button>
              </span>

              <span v-else>
                {{ props.formattedRow[props.column.field] || '-' }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>

      <b-modal
        id="modal-subcon-mapping"
        centered
        hide-footer
        :title="modalTitle"
        size="lg">
        <form @submit.prevent="saveMapping">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Parent Company <span class="text-danger">*</span></label>
                <v-select
                  v-validate="'required'"
                  name="Parent Company"
                  v-model="form.parent_company"
                  :options="companyOptions"
                  :reduce="option => option.company_name"
                  label="company_name"
                  placeholder="Cari parent company..."
                  :filterable="false"
                  :loading="companyOptionsLoading"
                  @search="onCompanySearch">
                  <template #no-options="{ search }">
                    <span v-if="search">Company tidak ditemukan</span>
                    <span v-else>Ketik nama company</span>
                  </template>
                </v-select>
                <span class="text-sm text-danger" v-show="errors.has('Parent Company')">
                  {{ errors.first('Parent Company') }}
                </span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Subcon Company <span class="text-danger">*</span></label>
                <v-select
                  v-validate="'required'"
                  name="Subcon Company"
                  v-model="form.child_company"
                  :options="companyOptions"
                  :reduce="option => option.company_name"
                  label="company_name"
                  placeholder="Cari subcon company..."
                  :filterable="false"
                  :loading="companyOptionsLoading"
                  @search="onCompanySearch">
                  <template #no-options="{ search }">
                    <span v-if="search">Company tidak ditemukan</span>
                    <span v-else>Ketik nama company</span>
                  </template>
                </v-select>
                <span class="text-sm text-danger" v-show="errors.has('Subcon Company')">
                  {{ errors.first('Subcon Company') }}
                </span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="custom-control custom-switch">
                <input
                  id="subcon-mapping-status"
                  v-model="form.is_active"
                  type="checkbox"
                  class="custom-control-input">
                <label class="custom-control-label" for="subcon-mapping-status">
                  Active
                </label>
              </div>
            </div>
          </div>

          <div class="form-group text-right mt-4">
            <button type="button" class="btn btn-secondary me-2" @click="$bvModal.hide('modal-subcon-mapping')">
              Cancel
            </button>
            <button class="btn btn-primary" type="submit" :disabled="isSaving">
              <span v-if="isSaving" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              {{ isSaving ? 'Saving...' : 'Save' }}
            </button>
          </div>
        </form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import subconMappingApi from '@/api/master-data/subcon-mapping/subcon-mapping';

export default {
  name: 'SubconMapping',
  data() {
    return {
      isLoading: false,
      isSaving: false,
      companyOptionsLoading: false,
      rows: [],
      companyOptions: [],
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
        totalPage: 1
      },
      filters: {
        search: '',
        status: null
      },
      form: {
        id: null,
        parent_company: '',
        child_company: '',
        is_active: true
      },
      statusOptions: [
        { label: 'Active', value: 'active' },
        { label: 'Inactive', value: 'inactive' }
      ],
      columns: [
        { label: 'No', field: 'no', width: '5%', sortable: false },
        { label: 'Parent Company', field: 'parent_company', sortable: true },
        { label: 'Subcon Company', field: 'child_company', sortable: true },
        { label: 'Status', field: 'is_active', sortable: true, width: '12%' },
        { label: 'Updated By', field: 'updated_by', sortable: true, width: '18%' },
        { label: 'Action', field: 'action', sortable: false, width: '12%', tdClass: 'text-center' }
      ]
    };
  },
  computed: {
    modalTitle() {
      return this.form.id ? 'Edit Mapping Subcon' : 'Add Mapping Subcon';
    }
  },
  created() {
    this.debouncedLoad = debounce(() => {
      this.pagination.page = 1;
      this.loadData();
    }, 500);
    this.debouncedLoadCompanyOptions = debounce((search) => {
      this.loadCompanyOptions(search);
    }, 350);
  },
  mounted() {
    this.loadData();
  },
  methods: {
    buildParams() {
      return {
        page: this.pagination.page,
        limit: this.pagination.limit,
        search: this.filters.search || undefined,
        status: this.filters.status || undefined
      };
    },
    async loadData() {
      this.isLoading = true;
      try {
        const response = await subconMappingApi.getAll(this.buildParams());
        const payload = response.data.data || {};
        this.rows = payload.data || [];
        this.pagination = {
          page: payload.page || 1,
          limit: payload.limit || this.pagination.limit,
          total: payload.total || 0,
          totalPage: payload.totalPage || 1
        };
      } catch (error) {
        this.$swal('Error', this.resolveError(error, 'Mapping subcon belum berhasil dimuat'), 'error');
      } finally {
        this.isLoading = false;
      }
    },
    async loadCompanyOptions(search = '') {
      this.companyOptionsLoading = true;
      try {
        const response = await subconMappingApi.getCompanyOptions({
          search,
          limit: 20
        });
        const companies = response.data.data || [];
        this.companyOptions = this.mergeSelectedCompanies([
          this.form.parent_company,
          this.form.child_company
        ], companies);
      } catch (error) {
        this.companyOptions = [];
      } finally {
        this.companyOptionsLoading = false;
      }
    },
    onCompanySearch(search) {
      this.companyOptionsLoading = true;
      this.debouncedLoadCompanyOptions(search);
    },
    onFilterChange() {
      this.debouncedLoad();
    },
    clearFilters() {
      this.filters = { search: '', status: null };
      this.pagination.page = 1;
      this.loadData();
    },
    onPageChange(params) {
      this.pagination.page = params.currentPage;
      this.loadData();
    },
    onPerPageChange(params) {
      this.pagination.limit = params.currentPerPage;
      this.pagination.page = 1;
      this.loadData();
    },
    resetForm() {
      this.form = {
        id: null,
        parent_company: '',
        child_company: '',
        is_active: true
      };
      if (this.$validator) this.$validator.reset();
    },
    openCreateModal() {
      this.resetForm();
      this.loadCompanyOptions();
      this.$bvModal.show('modal-subcon-mapping');
    },
    openEditModal(row) {
      this.form = {
        id: row.id,
        parent_company: row.parent_company || '',
        child_company: row.child_company || '',
        is_active: row.is_active !== false
      };
      this.companyOptions = this.mergeSelectedCompanies([
        row.parent_company,
        row.child_company
      ]);
      this.loadCompanyOptions();
      if (this.$validator) this.$validator.reset();
      this.$bvModal.show('modal-subcon-mapping');
    },
    mergeSelectedCompanies(companies = [], options = this.companyOptions || []) {
      const selectedOptions = companies
        .filter(Boolean)
        .map(companyName => ({ id: companyName, company_name: companyName }));
      const seen = new Set();
      return [...selectedOptions, ...options].filter((company) => {
        const key = String(company.company_name || '').trim().toLowerCase();
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    },
    async saveMapping() {
      const valid = await this.$validator.validateAll();
      if (!valid) return;

      this.isSaving = true;
      try {
        const payload = {
          parent_company: this.form.parent_company,
          child_company: this.form.child_company,
          is_active: this.form.is_active
        };

        if (this.form.id) {
          await subconMappingApi.update(this.form.id, payload);
        } else {
          await subconMappingApi.create(payload);
        }

        this.$bvModal.hide('modal-subcon-mapping');
        await this.loadData();
        this.$swal('Success', 'Mapping subcon berhasil disimpan', 'success');
      } catch (error) {
        this.$swal('Error', this.resolveError(error, 'Mapping subcon belum berhasil disimpan'), 'error');
      } finally {
        this.isSaving = false;
      }
    },
    toggleStatus(row) {
      const nextStatus = !row.is_active;
      this.$swal({
        title: nextStatus ? 'Activate mapping?' : 'Deactivate mapping?',
        text: `${row.parent_company} -> ${row.child_company}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: nextStatus ? '#00d97e' : '#e63757',
        cancelButtonColor: '#6c757d',
        confirmButtonText: nextStatus ? 'Ya, aktifkan' : 'Ya, nonaktifkan'
      }).then(async (result) => {
        if (!result.isConfirmed) return;
        try {
          await subconMappingApi.setStatus(row.id, nextStatus);
          await this.loadData();
          this.$swal('Success', 'Status mapping berhasil diupdate', 'success');
        } catch (error) {
          this.$swal('Error', this.resolveError(error, 'Status belum berhasil diperbarui'), 'error');
        }
      });
    },
    deleteMapping(row) {
      this.$swal({
        title: 'Hapus mapping?',
        text: `${row.parent_company} -> ${row.child_company}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#e63757',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Ya, hapus'
      }).then(async (result) => {
        if (!result.isConfirmed) return;
        try {
          await subconMappingApi.delete(row.id);
          if (this.rows.length === 1 && this.pagination.page > 1) {
            this.pagination.page -= 1;
          }
          await this.loadData();
          this.$swal('Success', 'Mapping subcon berhasil dihapus', 'success');
        } catch (error) {
          this.$swal('Error', this.resolveError(error, 'Mapping belum berhasil dihapus'), 'error');
        }
      });
    },
    resolveError(error, fallback) {
      return error?.response?.data?.error
        || error?.response?.data?.httpMessage
        || error?.response?.data?.message
        || error?.message
        || fallback;
    }
  }
};
</script>

<style scoped>
.me-1 {
  margin-right: 0.25rem;
}

.me-2 {
  margin-right: 0.5rem;
}
</style>
